import * as React from 'react';
import {Fragment, useState} from 'react';
import Paper from '@mui/material/Paper';
import FormControl from "@mui/material/FormControl";
import {Grid, InputLabel} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CasinoOutlinedIcon from '@mui/icons-material/CasinoOutlined';
import AddIcon from '@mui/icons-material/Add';
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {v4} from "uuid";
import {styled} from "@mui/material/styles";
import {ICharPresets} from "../../_interfaces/ICharPresets";
import {useSignals} from "@preact/signals-react/runtime";
import PresetsEdit from "./PresetsEdit";
import {
    s_char,
    s_char_matrices,
    s_char_presets,
    s_char_skills,
    s_char_talents,
    s_char_weapons
} from "../../_signals/s_char";
import {CharacterFieldUpdateField} from "../../_payload/CharacterFieldUpdateField";
import updChar from "../../_sig_api/updChar";
import {IRollerRoll} from "../../_interfaces/IRoller";
import {rollerOpen, rollerSetRoll} from "../../_helper/rollBehave";
import IconButton from "@mui/material/IconButton";
import {PresetsDelete} from "../../_api/BEPresets";
import {displayMod} from "../../_helper/displayMod";
import Skills from "../Skills/Skills";
import Talents from "../Talents/Talents";
import MatriceSpellWeaving from "../MatriceSpell/MatriceSpellWeaving";
import MatriceSpellCasting from "../MatriceSpell/MatriceSpellCasting";
import MatriceSpell from "../MatriceSpell/MatriceSpell";
import {s_app_mobile} from "../../_signals/s_app";
import AttributesDisplay from "../Attributes/AttributesDisplay";
import CharErholungsproben from "../Schaden/CharErholungsproben";
import {ICharTalent} from "../../_interfaces/ICharTalent";
import {ICharSkill} from "../../_interfaces/ICharSkill";
import {ICharWeapon} from "../../_interfaces/ICharWeapon";
import {s_char_attr_step} from "../../_signals/s_char_attr";
import Stack from "@mui/material/Stack";

const Item = styled('div')(({theme}) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff', ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'left',
    color: theme.palette.text.secondary,
}));


export default function Presets() {
    useSignals()

    const [edit, setEdit] = useState<null | ICharPresets>(null)
    const [add, setAdd] = useState(false)
    const [current, setCurrent] = useState<null | ICharPresets>(null)
    const step_values = [...Array(16).keys()];


    const empty = () => {
        const empty: ICharPresets = {
            id: v4(),
            cid: s_char.value.id,
            skill: '',
            talent: '',
            weapon: '',
            title: '',
            attribute: '',
            step: 0,
            step_calc: 0,
            step_weapon: 0,
            step_skill: 0,
            step_attribute: 0,
            step_talent: 0,
            fix_mod: 0,
            roll_mod: 0,
            strain: 0,
            karma: false,
            rollas: '',
            addSteps: 0,
            descr: ''
        }
        return empty
    }

    const remove = () => {
        if (!current) return
        PresetsDelete(current)
        setEdit(null)
        setCurrent(null)
    }

    const addSchaden = (dmg: number) => {
        const newSchaden = s_char.value.schaden + dmg;

        let upd: CharacterFieldUpdateField[] = [{k: 'schaden', v: newSchaden}];
        updChar(upd)
    }

    const roll = () => {
        if (!current) return;

        const strain = current.strain;
        const attribute = current.attribute;

        if (current.strain > 0) addSchaden(strain);

        let step = current.step > 0 ? current.step : current.step_calc;
        if (current.rollas === 'dmg') {
            const add = current.addSteps;
            step = step + (add * 2);
            setCurrent({...current, addSteps: 0});
        }
        if (step < 1) step = 1;

        const roll: IRollerRoll = {
            title: current.title,
            step: step,
            step_mod: current.roll_mod,
            strain: current.strain,
            as: current.rollas,
            attribute: '',
            karma: false,
            canusekarma: current.karma,
            target: [],
            targetVS: '',
            vs: 0,
            as_fix: false
        }

        rollerSetRoll(roll, true, false);
        rollerOpen()
    }

    const setCurrentPreset = (c: ICharPresets) => {
        if (c.talent) c.step_talent = s_char_talents.value.reduce((accumulator: number, cT: ICharTalent) => {
            if (cT.id === c.talent) return cT.step;
            return accumulator;
        }, 0);
        else c.step_talent = 0;
        if (c.skill) c.step_skill = s_char_skills.value.reduce((accumulator: number, cS: ICharSkill) => {
            if (cS.id === c.skill) return cS.step;
            return accumulator;
        }, 0);
        else c.step_skill = 0;
        if (c.weapon) c.step_weapon = s_char_weapons.value.reduce((accumulator: number, cW: ICharWeapon) => {
            if (cW.id === c.weapon) return cW.dmg + cW.dmg_mod;
            return accumulator;
        }, 0);
        else c.step_weapon = 0
        if (c.attribute) c.step_attribute = s_char_attr_step(c.attribute).value
        else c.step_attribute = 0;

        c.step_calc = c.step_skill + c.step_weapon + c.step_talent + c.step_attribute;

        setCurrent(c)
    }

    return <Paper style={{marginTop: 24}}>
        <Grid container>
            <Grid item xs={8}>
                <Item>
                    <FormControl fullWidth>
                        <Select
                            style={{textAlign: 'left'}}
                            value={current?.id ?? ''}
                        >
                            {s_char_presets.value.map((entry) =>
                                <MenuItem
                                    onClick={() => setCurrentPreset(entry)}
                                    key={entry.id}
                                    value={entry.id}>
                                    <Stack direction={'row'}
                                           spacing={0}
                                           style={{width: '100%'}}
                                           justifyContent="space-between"
                                           alignItems="stretch">
                                        <div>{entry.title}</div>

                                        <Stack className={'presetsStack'}
                                               direction={'column'}
                                               spacing={0}
                                               style={{marginLeft: 10}}>
                                            {entry.step > 0 ?
                                                <div>Stufe {entry.step}</div>
                                                :
                                                <Fragment>
                                                    {entry.talent ? <div>Talent</div> : null}
                                                    {entry.skill ? <div>Fertigkeit</div> : null}
                                                    {entry.weapon ? <div>Waffe</div> : null}
                                                    {entry.attribute ? <div>Attribut</div> : null}
                                                </Fragment>
                                            }
                                            {entry.fix_mod ? <div>{displayMod(entry.fix_mod)}</div> : null}
                                            {entry.karma ? <div className={'type'}>*Karma<br/></div> : null}
                                            {entry.rollas === 'ini' ? <div className={'type'}>*Initiative<br/></div> : null}
                                            {entry.rollas === 'dmg' ? <div className={'type'}>*Schaden<br/></div> : null}
                                            {entry.rollas === 'hit' ? <div className={'type'}>*Trefferwurf<br/></div> : null}
                                        </Stack>
                                    </Stack>
                                </MenuItem>)}
                        </Select>
                    </FormControl>
                </Item>
            </Grid>
            <Grid item xs={1}>
                <Item>
                    {current ? <EditIcon onClick={() => setEdit(current)}/> : null}
                </Item>
            </Grid>
            <Grid item xs={1}>
                <Item>
                    {current ? <IconButton onClick={() => remove()}><DeleteIcon/></IconButton> : null}
                </Item>
            </Grid>
            <Grid item xs={1}>
                <Item>
                    <AddIcon onClick={() => {
                        setEdit(empty());
                        setAdd(true)
                    }}/>
                </Item>
            </Grid>
            <Grid item xs={2}>
                <Item>
                    {current ? <Stack direction={'column'}>
                        {current.step > 0 ?
                            <div>Stufe: {current.step}</div> :
                            <div>Berechnete Stufe: {current.step_calc}</div>
                        }
                        {current.step_talent > 0 ? <div>Talent Stufe: +{current.step_talent}</div> : null}
                        {current.step_skill > 0 ? <div>Fertigkeit Stufe: +{current.step_skill}</div> : null}
                        {current.step_weapon > 0 ? <div>Waffe Stufe: +{current.step_weapon}</div> : null}
                        {current.attribute ? <div>Attribut {current.attribute.toUpperCase()} Stufe:
                            +{s_char_attr_step(current.attribute)}</div> : null}
                    </Stack> : null}
                </Item>
            </Grid>
            <Grid item xs={2}>
                <Item>
                    {current && current.rollas === 'dmg' ? <Fragment>
                        <FormControl variant="standard" style={{width: '100%'}}>
                            <InputLabel id="dialog-talent-label">Zusätzliche Erfolge</InputLabel>
                            <Select
                                value={current.addSteps}
                                onChange={(e) => setCurrent({...current, addSteps: e.target.value as number})}
                                variant="standard" type="number"
                                label="+ Erfolge:">
                                {step_values.map(r => <MenuItem key={v4()} value={r}>{r}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Fragment> : null}
                </Item>
            </Grid>
            <Grid item xs={1}>
                <Item>
                    {current ? <CasinoOutlinedIcon onClick={() => roll()}/> : null}
                </Item>
            </Grid>
        </Grid>
        {edit ? <PresetsEdit
            add={add}
            edit={edit}
            isOpen={() => setEdit(null)}
            updateCurrent={(e) => setCurrent(e)}
        /> : null}
    </Paper>

}
